import { ApiTypes } from "types"

export const dummyMeta: ApiTypes.Model.Pagination = {
  total: 2,
  per_page: 10,
  current_page: 1,
  last_page: 1,
  from: 1,
  to: 2,
}

export const dummyAlerts = [
  {
    id: 1,
    sn: "01-000-000001",
    address1: "",
    country: "Canada",
    state: "Alberta",
    city: "Calgary",
    zip: "T0L",
    date: "2024-11-26",
    datetime: "2024-11-26 12:00:00",
    status: "active",
    type: "offline",
    full_name: "John Doe",
    phone_number: "1234567890",
    email: "example@example.com",
    location: "Kitchen",
  },
  {
    id: 2,
    sn: "01-000-000002",
    address1: "",
    country: "Canada",
    state: "Alberta",
    city: "Calgary",
    zip: "T0L",
    date: "2024-11-26",
    datetime: "2024-11-26 12:00:00",
    status: "active",
    type: "online",
    full_name: "John Doe",
    phone_number: "1234567890",
    email: "sample@sample.com",
    location: "Dining Room",
  },
  {
    id: 3,
    sn: "01-000-000003",
    address1: "",
    country: "Canada",
    state: "Alberta",
    city: "Calgary",
    zip: "T0L",
    date: "2024-11-26",
    datetime: "2024-11-26 12:00:00",
    status: "active",
    type: "online",
    full_name: "John Doe",
    phone_number: "1234567890",
    email: "example2@example.com",
    location: "Living Room",
  },
]

export const dummyAlertsStatusesWidgetData: ApiTypes.Res.AlertStatusesWidget = {
  active: 1,
  frozen: 1,
  acknowledged: 1,
}

export const dummyAlertsWidgetData: ApiTypes.Model.AlertsWidgetData = {
  airQuality: 1,
  ambientSensorMalfunction: 1,
  fanMalfunction: 1,
  humiditySensorMalfunction: 1,
  offline: 1,
  efficiency_issue: 1,
  temperatureSensorMalfunction: 1,
  enrolledDevicesCount: 1,
  devicesWithActiveAlerts: 1,
  alertsCount: 1,
}
